module.exports = __webpack_public_path__ + "img/sunblock_sensi_icon.99fac357.png";